<template>
    <div class="dropdown" id="datatablePatientsColumns" v-cloak>
        <button
            type="button"
            class="btn btn-white btn-sm w-100"
            id="showHideDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            data-bs-auto-close="outside"
        >
            {{ $t('Columns') }}
            <!--            <span class="badge bg-soft-dark text-dark rounded-circle ms-1">-->
            <!--                {{ columns.filter(col => col.visible && col.columnSelector).length }}-->
            <!--            </span>-->
        </button>

        <div class="dropdown-menu dropdown-menu-end dropdown-card"
             aria-labelledby="showHideDropdown"
             style="width: 15rem;"
             data-popper-placement="bottom-end">
            <div class="card card-sm">
                <div class="card-body" style="max-height: 50vh; overflow: scroll;">
                    <div class="d-grid gap-3">
                        <template v-for="column in columns">
                            <!-- Form Switch -->
                            <label class="row form-check form-switch" :for="column.name" v-if="canToggle(column)">
                                <span class="col-8 col-sm-9 ms-0">
                                    <span class="me-2">{{ column.title }}</span>
                                </span>
                                <span class="col-4 col-sm-3 text-end">
                                    <input
                                        class="form-check-input"
                                        :id="column.name"
                                        :checked="isVisible(column)"
                                        @change="setVisibility($event, column)"
                                        type="checkbox"
                                    >
                                </span>
                            </label>
                            <!-- End Form Switch -->
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {trans as $t} from "@/vue/composables/missingTranslations";
const props = defineProps({
    columns: Array,
});
const emit = defineEmits(['set-visibility', 'delete']);
function setVisibility($event, col) {
    return emit('set-visibility', $event, col);
}
function isVisible(column) {
    return column.visible || !('visible' in column)
}
function canToggle(column) {
    return column.columnSelector !== false;
}
</script>
